@if (this.editOnly()) {
<div class="row normal-row parent-bck">
    @if (meta()?.helplong?.toString() != "") {
        <div class="info-help"><info description="{{meta()?.index | tkdata:'losdefhelp':{'default': meta()?.helplong?.toString()} | async}}" /></div>
    }
    <pre class="pre-eo" [title]="meta()?.index">{{meta()?.index | tkdata:'losdef':{'default': meta()?.omschr?.toString()} | async }}</pre>
    @if (meta()?.menunr != 0) {
    <div class="kanaal-group">
        <pre class="pre">{{valueLabel()}}</pre>
        <button #anchor kendoButton (click)="this.toggleEdit()" size="small" [themeColor]="'tertiary'">{{isEditing ? 'Close' : 'Edit'}}</button>
    </div>
    <kendo-popup *ngIf="isEditing" title="{{meta()?.index | tkdata:'losdef':{'default': meta()?.omschr?.toString()} | async }}" width="300px"
    [anchor]="anchor.element" #popup>
   <div>
       @for (item of this.menuService.getMenu(meta()!.menunr); track item.value) {
       <div>
           <kendo-checkbox #meta{{item.value}} [checkedState]="isChecked(item)" (checkedStateChange)="onCheckboxChange($event, item)"></kendo-checkbox>
           <kendo-label [for]="'meta' + item.value" text="{{item.sindex | tkdata:'losdefsmenu':{'default': item.omschr} | async}}"></kendo-label>
       </div>
       }
   </div>
    </kendo-popup>

    } @else {
    <div class="kanaal-group">
        @if (ioType() != undefined) {
            <kanaal-input [initialValue]="{ ioType: ioType()!, range: this.editVal.range! , start: this.editVal.waarde!, inverted: this.editVal.inverted}"
            [assignement]="this.assignment()"
            [autofilKanaal]="this.autoFill()" [maxKanaal]="this.paramRange().max"
            (valueChanged)="onKanaalInputChanged($event)" ></kanaal-input>
        } @else {
            <kendo-numerictextbox [(value)]="this.editVal.waarde!" [min]="this.paramRange().min" [max]="this.paramRange().max"  [autoCorrect]="true"
            [style]="{ width: '70px' }" (valueChange)="this.valueChanged.emit(this.editVal)"
            format="n0"></kendo-numerictextbox>

        }


    </div>
    }    
    </div>
} @else { 
    @if (this.isNew()) {
    <div class="row">
        
        <meta-select-button [alreadySelected]="this.alreadySelectedFN()" 
            [labelCbObs]="this.labelFn()"
            (onSelect)="this.onMetaSelected($event)"
            [availableMetas]="this.availableMetas()"></meta-select-button>
    </div>
    } @else {
    <div class="row condensed clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="this.open()">
        <pre class="pre" 
                title="{{meta()?.index}}  {{meta()?.index | tkdata:'losdefhelp':{'default': meta()?.helplong?.toString()} | async}}">{{meta()?.index | tkdata:'losdef':{'default': meta()?.omschr?.toString()} | async }}</pre>
        <div class="kanaal-group">
            <pre class="pre">{{valueLabel()}}</pre>
        </div>
    </div>
    }

    <kendo-dialog *ngIf="isEditing" 
        autoFocusedElement="#dfocus input"
        title="{{meta()?.index | tkdata:'losdefomschr':{'default': meta()?.omschrpr?.toString()} | async}}" width="500px" (close)="this.close()">
        @if (meta()?.menunr != 0) {
            <div class="wrapper" id="dfocus">
                <div class="menu">
                    @for (smenu of this.submenues(); track $index) {
                        <div class="smenu">
                            @for (item of smenu; track item.value) {
                            <div>
                                <kendo-checkbox #meta{{item.value}} [checkedState]="isChecked(item)" (checkedStateChange)="onCheckboxChange($event, item)"></kendo-checkbox>
                                <kendo-label [for]="'meta' + item.value" text="{{item.sindex | tkdata:'losdefsmenu':{'default': item.omschr} | async}}"></kendo-label>
                            </div>
                            }
                        </div>
                    }
                </div>
            </div>

        } @else {
        <div class="kanaal-container">
            @if (ioType() != undefined) {
                <kanaal-input id="dfocus" [initialValue]="{ ioType: ioType()!, range: this.editVal.range! , start: this.editVal.waarde!, inverted: this.editVal.inverted}" 
                [assignement]="this.assignment()"
                (valueChanged)="onKanaalInputChanged($event)" [maxKanaal]="this.paramRange().max" ></kanaal-input>
            } @else {
                <kendo-numerictextbox [tabIndex]="0" id="dfocus" [(value)]="this.editVal.waarde!"  [style]="{ width: '70px' }"
                [min]="this.paramRange().min" [max]="this.paramRange().max"  [autoCorrect]="true" format="n0"></kendo-numerictextbox>
    
            }
        </div>

        }
        <kendo-dialog-actions>
            <button kendoButton (click)="this.close()">Cancel</button>
            <button kendoButton (click)="onDelete()" themeColor="primary" *ngIf="!isNew()">
                Delete
            </button>
            <button kendoButton (click)="onSave()" themeColor="primary">
                Save
            </button>
        </kendo-dialog-actions>

    </kendo-dialog>
}